import { render, staticRenderFns } from "./FormLayoutFeedbackHelper.vue?vue&type=template&id=72e07610&"
import script from "./FormLayoutFeedbackHelper.vue?vue&type=script&lang=js&"
export * from "./FormLayoutFeedbackHelper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports